import "./Login.scss";

import { SvgIcon } from "@mui/material";
import TextInputField from "../../Components/TextInput/TextInputField";
import { useEffect, useState } from "react";
import { ReactComponent as eye } from "../../Assets/Images/eye.svg";
import { ReactComponent as ClosedEye } from "../../Assets/Images/closedEye.svg";
import ButtonField from "../../Components/Button/ButtonField";
import { Link, useNavigate } from "react-router-dom";
import IconButtonField from "../../Components/Button/IconButtonField";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import {
  clearLoginData,
  loginStart,
} from "../../Redux/Slicers/LoginSlicer/LoginSlicer";

import { useFormik } from "formik";
import * as Yup from "yup";
import { ILoginForm } from "./ILogin";
import FailureResponseDialog from "../../Components/FailureResponseDialog/FailureResponseDialog";
import Logo from '../../Assets/Images/navami_logo.webp';

const Login: React.FC = () => {
  const [show, setShow] = useState<boolean>(false);
  const nav = useNavigate();
  const dispatch = useAppDispatch();

  const loginResponse = useAppSelector((state) => state.LoginSlicer);

  const loginInitialValues: ILoginForm = {
    email: '',
    password: '',
  };

  const loginSchema = Yup.object({
    email: Yup.string()
      .email('Invalid Email')
      .required('Please enter your Email'),
    password: Yup.string().required('Please enter your password'),
  });

  const loginForm = useFormik({
    initialValues: loginInitialValues,
    validationSchema: loginSchema,
    onSubmit: (value) => {
      dispatch(loginStart(value));
    },
  });
  useEffect(() => {
    const getToken = localStorage.getItem('token');
    // Check if login was successful (either accessToken or token exists)
    if ((loginResponse.data?.accessToken || getToken) && !loginResponse.isLoading) {
      // Only navigate if there's no error
      if (!loginResponse.data?.responseCode || loginResponse.data?.responseCode === 200) {
        nav('/dashboard');
      }
    }
  }, [loginResponse, nav]);
  useEffect(() => {
    return () => {
      dispatch(clearLoginData());
    };
  }, []);

  return (
    <div className="backGround">
      <form
        className="main"
        onSubmit={loginForm.handleSubmit}>
        <>
          <div className="header">
            {/* <SvgIcon
              component={Logo}
              inheritViewBox
            /> */}
            <img
              src={Logo}
              alt="Navami Logo"
            />

            <div
              className="heading"
              style={{
                textAlign: 'center',
                color: '#a8cc3d',
                marginTop: '10px',
              }}>
              LOGIN
            </div>
            <div className="subHeading"></div>
          </div>

          <div className="textFields">
            <TextInputField
              className="textField"
              type="text"
              id="email"
              name="email"
              label="Email"
              value={loginForm.values.email}
              onChange={loginForm.handleChange}
              onBlur={loginForm.handleBlur}
              helperText={loginForm.touched.email && loginForm.errors.email}
              error={loginForm.touched.email && Boolean(loginForm.errors.email)}
            />

            <TextInputField
              type={show ? 'text' : 'password'}
              className="textField"
              id="password"
              name="password"
              label="Password"
              value={loginForm.values.password}
              onChange={loginForm.handleChange}
              onBlur={loginForm.handleBlur}
              helperText={
                loginForm.touched.password && loginForm.errors.password
              }
              error={
                loginForm.touched.password && Boolean(loginForm.errors.password)
              }
              InputProps={{
                endAdornment: (
                  <IconButtonField onClick={() => setShow(!show)}>
                    <SvgIcon
                      sx={{
                        width: '20px',
                        height: '20px',
                      }}
                      component={show ? eye : ClosedEye}
                      inheritViewBox
                    />
                  </IconButtonField>
                ),
              }}
            />
            <Link
              to={'/forgot-password-mail'}
              className="forgetPassword">
              Forgot Password
            </Link>
          </div>

          <div>
            <ButtonField
              className="buttonfield"
              type="submit"
              size="large">
              Proceed
            </ButtonField>
          </div>
        </>
      </form>
      <FailureResponseDialog response={loginResponse.data} />
    </div>
  );
};

export default Login;
